/* eslint-disable import/first */
import React from 'react';

export default function AddressDropdown(props) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="19" height="19" fill="#F2F2F2" />
      <g id="8.1_Home_First Time User" clip-path="url(#clip0_0_80916)">
        <rect width="390" height="1956" transform="translate(-283 -130)" fill="#F7FAFE" />
        <g id="Rectangle" filter="url(#filter0_d_0_80916)">
          <rect x="-268" y="-14" width="300" height="48" rx="10" fill="white" />
        </g>
        <g id="ic_dropdown">
          <path id="Rectangle_2" d="M19 9.5C19 16.3945 16.7412 19 9.5 19C2.25883 19 0 16.3966 0 9.5C0 2.60337 2.25883 0 9.5 0C16.7422 0 19 2.60549 19 9.5Z" fill="#EE3A43" />
          <path id="arrow / chevron_big_down" d="M9.41588 13.1416L13.5141 9.07017L12.8311 8.3916L9.41588 11.7845L6.00069 8.3916L5.31766 9.07017L9.41588 13.1416Z" fill="white" stroke="white" stroke-width="0.633333" />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_0_80916" x="-272" y="-16" width="308" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.902639 0 0 0 0 0.93472 0 0 0 0 0.977494 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_80916" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_80916" result="shape" />
        </filter>
        <clipPath id="clip0_0_80916">
          <rect width="390" height="1956" fill="white" transform="translate(-283 -130)" />
        </clipPath>
      </defs>
    </svg>

  );
}
